import { Flex, Form, Select } from "antd";
import { useEffect, useState } from "react";
import RESTConfiguration from "./rest-configuration";
import SFTPConfiguration from "./sftp-configuration";
import SOAPConfiguration from "./soap-configuration";
import NoChannelConfiguration from "./no-channel-configuration";
import TrustedDriverConfiguration from "./trusted-driver-configuration";
import { Client } from "../../model/client-model";

const channelTypes = [
    { label: 'Trusted Driver Local DB', value: 'TD_LOCAL' },
    { label: 'REST', value: 'REST' },
    { label: 'Secure FTP', value: 'SFTP' },
    { label: 'SOAP', value: 'SOAP' },
]
  
const SourceConfiguration = ({show, client, channelField, onBack, onNext, onClose}: any) => {

    const [sourceChannelType, setSourceChannelType] = useState<string>('');

    const [form] = Form.useForm();

    useEffect(() => {
        form.setFieldsValue(channelField);
        setSourceChannelType(client?.sourceChannelType);
    }, [client]);

    const onSubmit = (client: Client) => {
        onNext({...client, sourceChannelType});
    }

    return <div className="clients-page-form" style={{overflow: 'hidden', height: show ? 'auto' : '0rem'}}>

        <h2>Source Configuration</h2>

        <Flex vertical>
            <label>Channel Type</label>
            <Select value={sourceChannelType} options={channelTypes} onChange={setSourceChannelType} />
        </Flex>
        
        <TrustedDriverConfiguration client={client} 
            show={sourceChannelType === 'TD_LOCAL'} 
            channelField={'source'}
            onBack={onBack} 
            onNext={onSubmit} 
            onClose={onClose}
        />
        <RESTConfiguration client={client} 
            show={sourceChannelType === 'REST'} 
            channelField={'source'}
            onBack={onBack} 
            onNext={onNext} 
            onClose={onClose}
        />
        <SFTPConfiguration client={client} 
            show={sourceChannelType === 'SFTP'} 
            channelField={'source'}
            onBack={onBack} 
            onNext={onSubmit} 
            onClose={onClose}
        />
        <SOAPConfiguration client={client} 
            show={sourceChannelType === 'SOAP'} 
            channelField={'source'}
            onBack={onBack} 
            onNext={onNext} 
            onClose={onClose}
        />
        <NoChannelConfiguration client={client} 
            show={sourceChannelType == null} 
            channelField={'source'}
            onBack={onBack} 
            onSave={onNext} 
            onClose={onClose}
        />
    </div>
}

export default SourceConfiguration;